import { useCustomerParents } from "./useCustomerParents";

export default useCustomerParents;
